import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";

// База API. Управляется через env: прод — https://www.sunpanda.ru,
// тест — https://test.sunpanda.ru. Если переменная не задана, падаем на
// прод-домен, чтобы поведение прод-сборки не менялось.
const API_URL = process.env.REACT_APP_API_URL || "https://www.sunpanda.ru";

export const authentication = axios.create({
    baseURL: API_URL + "/auth",
});

export const parentApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: API_URL,
        prepareHeaders: async (headers) => {
            const token = localStorage.getItem("accessToken");
            token && headers.set("Authorization", "Bearer " + token);
            return headers;
        },
    }),
    refetchOnReconnect: true,
    tagTypes: ["SLIDES", "RESTAURANTS"],
    endpoints: () => ({}),
});
